import React from "react";
import styles from "../../styles/FaqPageStyle.module.css";
import { Card, CardBody, Collapse } from "reactstrap";
import { useState } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from "react-icons/ai";
import Question from "../../assets/imgs/EF Branding Website/334731_quora_icon.png";
import Answer from "../../assets/imgs/EF Branding Website/letter-a (1).png";

const QuesTwo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <img src={Question} alt="" style={{ width: "30px", height: "30px" }} />
        <button id="toggler2" className={styles.btn} onClick={toggle}>
          <span style={{ textAlign: "left" }}>
            What are the services provided by Easy Freight Logistics company?
          </span>
          {!isOpen ? (
            <div className={styles.icon_container}>
              <AiOutlinePlusCircle className={styles.icon} />
            </div>
          ) : (
            <div className={styles.icon_container}>
              <AiOutlineMinusCircle className={styles.icon} />
            </div>
          )}
        </button>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="d-flex mt-3">
          <img src={Answer} alt="" className={styles.img} />
          <Card style={{ width: "100%" }}>
            <CardBody>
              <span>The services include</span>
              <ul className="mt-4">
                <li>
                  ● Freight Forwarding solutions: Ocean Freight and Land Freight
                </li>
                <li> ● General freight forwarding</li>
                <li>
                  ● Project freight forwarding (Onestop service for trading
                  company)
                </li>
                <li>● Full container load (FCL) </li>
                <li> ●Less than Container Load (LCL)</li>
                <li>
                  ● International/intercontinental cargo shipping solutions
                </li>
                <li>● Delivery services by truck</li>
                <li> ● Multimodal solutions</li>
                <li> ● Heavy lift cargo handling</li>
                <li> ● Customs clearance documentation</li>
                <li> ● Insurance</li>
                <li> ● Storage</li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};
export default QuesTwo;
